import { useFormContext } from "react-hook-form";
import type { ConfirmDebtForm } from "./use-confirm-debt-form";

/**
 * Saves the added debt at an index, or marks the fields that keep it from
 * being saved. Resolves to whether it was saved.
 */
export const useSaveAddedDebt = () => {
	const { trigger, setValue } = useFormContext<ConfirmDebtForm>();

	return async (index: number): Promise<boolean> => {
		const name = `addedDebts.${index}` as const;
		if (!(await trigger([`${name}.type`, `${name}.amount`]))) return false;

		setValue(`${name}.saved`, true, {
			shouldDirty: true,
			shouldValidate: true,
		});
		return true;
	};
};
